import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { ChevronRight, Upload, FileArchive } from 'lucide-react';
import { Alert, AlertDescription } from '../ui/alert';

export default function SubidaMasivaForm({ initialData, onSubmit }) {
  const [formData, setFormData] = useState({
    descripcion: initialData?.descripcion || '',
    mes_gastos: initialData?.mes_gastos || new Date().toISOString().slice(0, 7),
    num_facturas_aprox: initialData?.num_facturas_aprox || 10,
    observaciones: initialData?.observaciones || '',
  });
  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors(prev => ({ ...prev, [field]: null }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.descripcion || formData.descripcion.length < 10) {
      newErrors.descripcion = 'Mínimo 10 caracteres';
    }
    if (formData.num_facturas_aprox < 1) {
      newErrors.num_facturas_aprox = 'Debe ser al menos 1';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <Alert className="bg-blue-50 border-blue-200">
        <FileArchive className="h-4 w-4 text-blue-600" />
        <AlertDescription className="text-blue-800">
          La subida masiva de gastos permite enviar múltiples facturas de proveedores en un solo proceso.
          Prepara un archivo ZIP con todas las facturas en PDF.
        </AlertDescription>
      </Alert>

      <div className="space-y-4">
        <div>
          <Label>Descripción de la Subida *</Label>
          <Textarea
            value={formData.descripcion}
            onChange={(e) => handleChange('descripcion', e.target.value)}
            placeholder="Ej: Gastos de enero 2025 - suministros y servicios profesionales"
            rows={3}
            className={errors.descripcion ? 'border-red-500' : ''}
            data-testid="input-descripcion"
          />
          {errors.descripcion && <p className="text-red-500 text-xs mt-1">{errors.descripcion}</p>}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label>Mes de los Gastos *</Label>
            <Input
              type="month"
              value={formData.mes_gastos}
              onChange={(e) => handleChange('mes_gastos', e.target.value)}
              data-testid="input-mes-gastos"
            />
          </div>
          <div>
            <Label>Número Aproximado de Facturas *</Label>
            <Input
              type="number"
              min="1"
              max="100"
              value={formData.num_facturas_aprox}
              onChange={(e) => handleChange('num_facturas_aprox', parseInt(e.target.value) || 1)}
              className={errors.num_facturas_aprox ? 'border-red-500' : ''}
              data-testid="input-num-facturas"
            />
            {errors.num_facturas_aprox && <p className="text-red-500 text-xs mt-1">{errors.num_facturas_aprox}</p>}
          </div>
        </div>

        <div className="border-2 border-dashed border-slate-300 rounded-lg p-8 text-center bg-slate-50">
          <Upload className="w-12 h-12 text-slate-400 mx-auto mb-4" />
          <p className="text-slate-600 mb-2">Arrastra aquí tu archivo ZIP con las facturas</p>
          <p className="text-sm text-slate-500 mb-4">o</p>
          <Button type="button" variant="outline">
            Seleccionar archivo
          </Button>
          <p className="text-xs text-slate-500 mt-4">Formatos aceptados: ZIP (máx 50MB)</p>
        </div>

        <div>
          <Label>Observaciones</Label>
          <Textarea
            value={formData.observaciones}
            onChange={(e) => handleChange('observaciones', e.target.value)}
            placeholder="Información adicional sobre los gastos..."
            rows={2}
          />
        </div>
      </div>

      <Button type="submit" className="w-full" data-testid="btn-submit-form">
        Continuar <ChevronRight className="w-4 h-4 ml-2" />
      </Button>
    </form>
  );
}
